module.exports = __webpack_public_path__ + "39df665459be99517906c09268b76806.svg";